import { IPetCommon } from './pet.interfaces';
import { Action } from '@ngrx/store';
import { Pet } from './../../../shared/models/pet';

export enum PetActionTypes {
  FETCH_PETS = '[Pet] Fetch Pets',
  FETCH_PETS_SUCCESS = '[Pet] Fetch Pets Success',
  FETCH_PETS_FAILURE = '[Pet] Fetch Pets Failure',
  ADD_PET = '[Pet] Add Pet',
  ADD_PET_SUCCESS = '[Pet] Add Pet Success',
  ADD_PET_FAILURE = '[Pet] Add Pet Failure',
  DELETE_PET = '[Pet] Delete Pet',
  DELETE_PET_SUCCESS = '[Pet] Delete Pet Success',
  DELETE_PET_FAILURE = '[Pet] Delete Pet Failure',
  UPDATE_PET = '[Pet] Update Pet',
  UPDATE_PET_SUCCESS = '[Pet] Update Pet Success',
  UPDATE_PET_FAILURE = '[Pet] Update Pet Failure',
  REMOVE_ALL_PETS = '[Pet] Remove All Pets'
}

export class FetchPets implements Action {
  readonly type = PetActionTypes.FETCH_PETS;
  constructor(public payload: number) {}
}

export class FetchPetsSuccess implements Action {
  readonly type = PetActionTypes.FETCH_PETS_SUCCESS;
  constructor(public payload: IPetCommon[]) {}
}

export class FetchPetsFailure implements Action {
  readonly type = PetActionTypes.FETCH_PETS_FAILURE;
  constructor(public payload: string) {}
}

export class AddPet implements Action {
  readonly type = PetActionTypes.ADD_PET;
  constructor(public payload: Pet) {}
}

export class AddPetSuccess implements Action {
  readonly type = PetActionTypes.ADD_PET_SUCCESS;
  constructor(public payload: IPetCommon) {}
}

export class AddPetFailure implements Action {
  readonly type = PetActionTypes.ADD_PET_FAILURE;
  constructor(public payload: string) {}
}

export class DeletePet implements Action {
  readonly type = PetActionTypes.DELETE_PET;
  constructor(public payload: number) {}
}

export class DeletePetSuccess implements Action {
  readonly type = PetActionTypes.DELETE_PET_SUCCESS;
  constructor(public payload: number) {}
}

export class DeletePetFailure implements Action {
  readonly type = PetActionTypes.DELETE_PET_FAILURE;
  constructor(public payload: string) {}
}

export class UpdatePet implements Action {
  readonly type = PetActionTypes.UPDATE_PET;
  constructor(public payload: Pet) {}
}

export class UpdatePetSuccess implements Action {
  readonly type = PetActionTypes.UPDATE_PET_SUCCESS;
  constructor(public payload: IPetCommon) {}
}

export class UpdatePetFailure implements Action {
  readonly type = PetActionTypes.UPDATE_PET_FAILURE;
  constructor(public payload: string) {}
}

export class RemoveAllPets implements Action {
  readonly type = PetActionTypes.REMOVE_ALL_PETS;
}


export type PetActions = FetchPets
| FetchPetsSuccess
| FetchPetsFailure
| AddPet
| AddPetSuccess
| AddPetFailure
| UpdatePet
| UpdatePetSuccess
| UpdatePetFailure
| RemoveAllPets
| DeletePet
| DeletePetSuccess
| DeletePetFailure;
